import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { PageElement } from './Page';

const City = lazy(() =>
    import('@/v1/setting/views/City').then((module) => ({
        default: module.City,
    }))
);
const District = lazy(() =>
    import('@/v1/setting/views/District').then((module) => ({
        default: module.District,
    }))
);

export const areaSettingRoutes: RouteObject[] = [
    {
        path: `city`,
        ...PageElement(<City />),
    },
    {
        path: `district`,
        ...PageElement(<District />),
    },
];
